import { createFileRoute } from '@tanstack/react-router';
import { ForgotPasswordPage } from '../../pages';

export const Route = createFileRoute('/_auth/forgot-password')({
  staticData: {
    pageName: 'Forgot Password',
  },
  component: ForgotPasswordPage,
});
